enum ApiItemTypeEnum {
    Message = 1,
    Appointment = 2,
    MeetingRequest = 3,
    MessageCompose = 4,
    AppointmentCompose = 5,
}

export default ApiItemTypeEnum;
